<template>
  <div :class="{'tela-cheia': tela_cheia, normal: !tela_cheia}" class="bg-white">
    <div v-show="tela_cheia" id="bloco-titulo">
      <v-btn icon dark @click="tela_cheia = !tela_cheia">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <span v-text="titulo" class="ml-5 text-white font-21 font-weight-medium" />
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: "TelaCheia",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: ""
    }
  },
  computed: {
    tela_cheia: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit("update:modelValue", valor);
      }
    }
  }
}
</script>

<style scoped>
.tela-cheia {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
.normal {
  top: auto;
  transition: top 2s;
}
#bloco-titulo {
  background: #042333;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 10px;
}
</style>
